import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import { CartActions } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';

class CouponForm extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      couponCode: '',
      message: null
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // Clears out message after any other action in cart
    // Clears out coupon code input only after API returns with success/fail
    const { validCoupon } = this.props;

    // MUST check for `null` and `false` because default is `null`
    if (validCoupon === null && newProps.validCoupon) {
      this.setState({
        message: 'success',
        couponCode: ''
      });
    } else if (validCoupon === null && newProps.validCoupon === false) {
      this.setState({
        message: 'fail',
        couponCode: ''
      });
    } else {
      this.setState({ message: null });
    }
  }

  handleApplyCoupon = (e) => {
    e.preventDefault();
    const { couponCode } = this.state;

    if (couponCode) {
      document.activeElement && document.activeElement.blur();
      CartActions.applyCoupon(couponCode)
        .then((data) => {
          const { valid } = data;
          Metrics.track(MetricEvents.OLS_CART_APPLYCOUPON({ valid }));
        });
    }
  }

  renderMessage() {
    const translate = this.context.translate || (() => {});
    const { message } = this.state;
    const successMessage = message === 'success';
    const { Block } = UX2.Element;

    return message
      ? <Block
        children={ translate(
          successMessage ? 'coupon.validCoupon' : 'coupon.invalidCoupon'
        ) }
        style={{
          marginTop: 'xxsmall',
          marginBottom: '0',
          fontColor: successMessage ? 'highlight' : 'error'
        }}
      />
      : null;
  }

  handleInputFieldKeyDown = (e) => {
    // Prevents `enter` key from submitting checkout
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleApplyCoupon(e);
    }
  }

  render() {
    const translate = this.context.translate || (() => {});
    const { couponCode } = this.state;
    const { Block, Input, Link } = UX2.Element;

    const styles = {
      outer: {
        'width': '100%',
        '@sm': {
          width: 'auto'
        }
      },
      inner: {
        display: 'flex',
        alignItems: 'center'
      },
      input: {
        fontSize: 'medium',
        borderRadius: 'medium',
        borderWidth: 'xsmall',
        borderStyle: 'solid',
        borderColor: 'section',
        padding: 'xsmall',
        marginRight: 'medium',
        outline: 'none'
      },
      link: {
        textTransform: 'uppercase',
        fontSize: 'medium',
        WebkitAppearance: 'none'
      }
    };

    return (
      <Block style={ styles.outer }>
        <Block style={ styles.inner }>
          <Input
            data-aid={ dataAids.COUPON_INPUT_FIELD }
            onKeyDown={ this.handleInputFieldKeyDown }
            onChange={ e => this.setState({ couponCode: e.target.value }) }
            value={ couponCode }
            placeholder={ translate('coupon.desktopCouponCode') }
            style={ styles.input }
            disabled={ this.props.fetching }
          />
          <Link
            data-aid={ dataAids.COUPON_APPLY_BTN }
            onTouchStart={ this.handleApplyCoupon }
            onMouseDown={ this.handleApplyCoupon }
            type='submit'
            children={ translate('coupon.apply') }
            style={ styles.link }
            href='javascript:;'
            disabled={ this.props.fetching }
          />
        </Block>
        {this.renderMessage()}
      </Block>
    );
  }
}

CouponForm.defaultProps = {
  validCoupon: null,
  fetching: false
};

CouponForm.propTypes = {
  validCoupon: PropTypes.bool,
  fetching: PropTypes.bool
};

CouponForm.contextTypes = {
  translate: PropTypes.func
};

export default CouponForm;
